var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#636799"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6406 9.35999C12.6777 9.35999 8.64062 13.3971 8.64062 18.36C8.64062 23.3229 12.6777 27.36 17.6406 27.36C22.6035 27.36 26.6406 23.3222 26.6406 18.36C26.6406 13.3978 22.6035 9.35999 17.6406 9.35999ZM17.6406 25.9657C13.4474 25.9657 10.0349 22.554 10.0349 18.36C10.0349 14.166 13.4474 10.7542 17.6406 10.7542C21.8339 10.7542 25.2464 14.166 25.2464 18.36C25.2464 22.554 21.8346 25.9657 17.6406 25.9657Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1255 17.6001H18.337V14.8115C18.337 14.4267 18.0254 14.1144 17.6399 14.1144C17.2543 14.1144 16.9427 14.4267 16.9427 14.8115V17.6001H14.1542C13.7687 17.6001 13.457 17.9124 13.457 18.2972C13.457 18.682 13.7687 18.9943 14.1542 18.9943H16.9427V21.7829C16.9427 22.1677 17.2543 22.48 17.6399 22.48C18.0254 22.48 18.337 22.1677 18.337 21.7829V18.9943H21.1255C21.511 18.9943 21.8227 18.682 21.8227 18.2972C21.8227 17.9124 21.511 17.6001 21.1255 17.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/AddNew.d3c4e029.svg";
export { ForwardRef as ReactComponent };